// import { config } from 'aws-sdk';
import { CloudWatchLogs } from '@aws-sdk/client-cloudwatch-logs';
import { injectable } from 'inversify';
import 'reflect-metadata';
import { getEnvConfig } from '@/_shared/models/enviroment.model';

@injectable()
export class LogHelper {
  cloudWatchLogs: CloudWatchLogs;
  configValues: any;

  constructor(cloudWatchLogs = new CloudWatchLogs()) {
    this.cloudWatchLogs = cloudWatchLogs;
  }

  async init() {
    this.configValues = await getEnvConfig();
    // config.update({
    //   region: this.configValues.REGION,
    //   credentials: {
    //     accessKeyId: this.configValues.ACCESS_KEY_ID!,
    //     secretAccessKey: this.configValues.ACCESS_KEY_SECRET!,
    //   },
    // });
  }

  async createLogStream(logGroupName: string, logStreamName: string) {
    const params = {
      logGroupName,
      logStreamName,
    };
    await this.cloudWatchLogs.createLogStream(params);
  }

  async postLogToCloudWatch(logMessage: string, userId: number) {
    try {
      if (!this.configValues) {
        await this.init();
      }

      const logGroupName = this.configValues.CLOUDWATCH_LOGGROUP!;
      const logStreamName = `${this.configValues.CLOUDWATCH_LOGSTREAM!}-user-${userId}`;

      const params = {
        logGroupName,
        logStreamName,
        logEvents: [
          {
            message: logMessage,
            timestamp: new Date().getTime(),
          },
        ],
      };

      try {
        await this.cloudWatchLogs.putLogEvents(params);
      } catch {
        await this.createLogStream(logGroupName, logStreamName);
        await this.cloudWatchLogs.putLogEvents(params);
      }
    } catch {
      return 'Unable to post a log on CloudWatch';
    }
  }
}

export default LogHelper;
